<template>
    <div class="grid grid-cols-2 gap-12">
        <div
            v-for="(seller, index) in sellers"
            :key="index"
            class="flex flex-col justify-between "
        >
            <div class="flex space-x-3">
                <div class="">
                    <h4 class="text-2xl font-semibold text-output-secondary">
                        {{ seller.name }}
                    </h4>
                    <h5 class="font-semibold leading-none text-output-primary">
                        {{ seller.type }}
                    </h5>
                    <div class="flex mt-1 space-x-2 ">
                        <h5 class="font-semibold text-output-primary">
                            Origine :
                        </h5>
                        <p>{{ seller.clientOrigin }}</p>
                    </div>
                </div>
                <div class="">
                    <div class="flex space-x-2">
                        <h5 class="font-semibold text-output-primary">
                            % du CA :
                        </h5>
                        <p>{{ seller.caPercentage }}%</p>
                    </div>
                    <div class="flex space-x-2">
                        <h5 class="font-semibold text-output-primary">
                            Délai de paiement :
                        </h5>
                        <p>{{ seller.paymentDeadline }} jours</p>
                    </div>
                    <div>
                        <h5 class="font-semibold text-output-primary">
                            Modalités de paiement :
                        </h5>

                        <span
                            v-for="(payment, index) in seller.paymentType"
                            :key="index"
                            class="mx-px rounded-xl bg-output-blue-200"
                        >
                            <b class="px-2 font-semibold">{{
                                payment
                            }}</b></span
                        >
                    </div>
                </div>
            </div>
            <hr class="w-10/12 h-px mt-1 bg-output-secondary" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sellers: {
            type: Array,
            required: true
        }
    },
    computed: {}
};
</script>

<style></style>
